import styled, { css } from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { Button } from '../../Button';
import { getEllipticableCss } from '../../typography';

export interface SegmentedControlItemProps {
    checked?: boolean;
    disabled?: boolean;
    itemWidth?: 'evenly' | 'content';
    vertical?: boolean;
}

export const SegmentedControlButton = styled(Button).attrs<SegmentedControlItemProps>(({ size, vertical }) => ({
    size: vertical ? size || 'small' : 'small',
}))<SegmentedControlItemProps>`
    height: ${({ vertical }) => (!vertical ? '100%' : undefined)};
    min-width: 0;
    border: none;
    overflow: auto;
    padding: 0 ${getSpacingToken('200')}px;

    ${({ itemWidth, vertical }) =>
        !vertical &&
        css`
            flex: ${itemWidth === 'content' ? '0 0 auto' : '1'};
        `}

    &:disabled {
        background-color: ${getToken('backgroundInteractiveNeutralDefault')};
        color: ${getToken('textDisabled')};
    }

    &:not([disabled]) {
        background-color: ${({ checked }) =>
            getToken(checked ? 'backgroundStaticFlat' : 'backgroundInteractiveNeutralDefault')};

        &:hover {
            background-color: ${({ checked }) =>
                getToken(checked ? 'backgroundStaticFlat' : 'backgroundInteractiveNeutralHover')};
        }

        &:active {
            background-color: ${({ checked }) =>
                getToken(checked ? 'backgroundStaticFlat' : 'backgroundInteractiveNeutralActive')};
        }

        &:focus-visible {
            outline-offset: -${getSpacingToken('25')}px;
        }
    }

    ${({ checked }) =>
        checked &&
        css`
            font-weight: ${getToken('fontWeight600')};
        `}

    & > * {
        ${getEllipticableCss({ ellipsis: true })};
    }
`;
